import $ from 'jquery'
import React, { Component } from 'react'
import { Link } from 'gatsby'
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback,
} from 'reactstrap'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import Logo from './../../assets/images/logo.png'
import Search from './../../assets/images/search.svg'
import CloseBtn from './../../assets/images/close__btn.png'
import axios from 'axios'
import NoPurchases from './../../assets/images/no-purchase.svg'
import Cookies from 'universal-cookie'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import _ from 'lodash'
import { HOSTNAME } from '../config'
const cookies = new Cookies()

let initialState = {
  user: {},
  amount: '',
  items: '',
  description: '',
  brandKey: '',
  err: {},
  resMessage: '',
  resType: '',
  purchase: [],
  purchaseModal: false,
  purchaseId: '',
  brandTitle: '',
  isLoading: false,
}

class MyPurchase extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    if (e.target.name === 'amount') {
      this.state.err.amount = ''
    }
    if (e.target.name === 'items') {
      this.state.err.items = ''
    }
    if (e.target.name === 'description') {
      this.state.err.description = ''
    }
    if (e.target.name === 'brandKey') {
      this.state.err.brandKey = ''
    }
    this.setState({ [e.target.name]: e.target.value })
  }

  componentDidMount() {
    const user = cookies.get('user')
    if (user) {
      this.setState({ user: user })
      let obj = {}
      obj.userId = user._id
      this.getPurchase(obj)
      this.getBrands()
      setTimeout(function() {
        document.title = 'Purchases | American Field'
        let meta = document.getElementsByTagName('meta')
        for (var i = 0; i < meta.length; i++) {
          if (meta[i].name.toLowerCase() === 'description') {
            meta[i].content = 'Purchases | American Field'
          }
          if (meta[i].name.toLowerCase() === 'url') {
            meta[i].content = 'https://app.shopaf.co/purchases'
          }
        }
      }, 300)
    }
  }

  getBrands() {
    let self = this
    axios
      .get(HOSTNAME + 'getBrands')
      .then(function(response) {
        let res = response.data
        if (res.success) {
          self.props.brands(res.data)
        }
      })
      .catch(function(error) {
        self.props.brands([])
      })
  }

  getPurchase(obj) {
    let self = this
    axios
      .post(HOSTNAME + 'getPurchase', obj)
      .then(function(response) {
        let res = response.data
        if (res.success) {
          self.setState({ purchase: res.data })
        }
      })
      .catch(function(error) {
        self.setState({ purchase: [] })
      })
  }

  submitForm(event) {
    event.preventDefault()
    const { location } = this.props
    const {
      amount,
      items,
      description,
      brandKey,
      user,
      purchaseId,
    } = this.state
    let self = this
    const err = {}
    if (amount === '') {
      err.amount = 'Please enter amount'
    }
    if (items === '') {
      err.items = 'Please enter items'
    }
    if (description === '') {
      err.description = 'Please enter description'
    }
    // if (brandKey === '') {
    //   err.brandKey = 'Please enter brand key';
    // }
    this.setState({ err })
    if (!Object.keys(err).length) {
      window &&
        window.ga &&
        window.ga('send', 'event', {
          eventCategory: 'Log Purchases',
          eventAction: 'Log a Purchase Submit',
          eventLabel: 'Log a Purchase Submit',
          transport: '1',
        })
      this.setState({ isLoading: true })
      let obj = { items, description, brandKey }
      obj.amount = String(amount).replace(/\D/g, '')
      if (purchaseId !== '') {
        obj.purchaseId = purchaseId
      }
      axios
        .post(HOSTNAME + 'savePurchase', obj)
        .then(function(response) {
          let res = response.data
          if (res.success) {
            let val = {}
            val.userId = user._id
            self.getPurchase(val)
            self.setState({
              isLoading: false,
              resMessage: res.message,
              resType: 'alert alert-success',
            })
            self.resetState()
            setTimeout(function() {
              self.setState({ resMessage: '', resType: '' })
            }, 2000)
          } else {
            self.setState({
              resMessage: res.message,
              resType: 'alert alert-danger',
            })
            setTimeout(function() {
              self.setState({ isLoading: false, resMessage: '', resType: '' })
            }, 2000)
          }
        })
        .catch(function(error) {
          self.setState({
            isLoading: false,
            resMessage: error,
            resType: 'alert alert-danger',
          })
        })
    }
  }

  editPurchase(val) {
    window &&
      window.ga &&
      window.ga('send', 'event', {
        eventCategory: 'Log Purchases',
        eventAction: 'Log a Purchase Edit Clicked',
        eventLabel: 'Log a Purchase Edit Clicked',
        transport: '1',
      })
    this.setState({
      purchaseModal: true,
      purchaseId: _.get(val, '_id', ''),
      amount: _.get(val, 'amount', 0),
      items: _.get(val, 'items', 0),
      description: _.get(val, 'description', 0),
      brandKey: _.get(val, 'brandKey', 0),
      brandTitle: _.get(val, 'brandId.title', ''),
    })
  }

  resetState() {
    this.setState({
      purchaseModal: false,
      err: {},
      brandTitle: '',
      items: '',
      amount: '',
      description: '',
      brandKey: '',
      purchaseId: '',
    })
  }

  render() {
    const {
      user,
      resMessage,
      brandTitle,
      resType,
      err,
      purchase,
      purchaseModal,
      amount,
      items,
      description,
      brandKey,
      isLoading,
    } = this.state
    return (
      <div>
        {resMessage !== '' && (
          <div className={resType}>
            <strong>{resMessage}</strong>
          </div>
        )}
        <div className="my__purchase--page">
          <section className="my__purchase--section">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <ul className="purchases__details--list">
                    {purchase && purchase.length > 0 ? (
                      purchase.map((val, index) => {
                        return (
                          <li key={index}>
                            <div className="date__year">
                              <div>{val.brandId.title}</div>
                              <div className="sub__title">
                                {moment(val.createDate).format('MMMM D, YYYY')}
                              </div>
                            </div>
                            <div className="currency__edite">
                              <span>${parseFloat(val.amount).toFixed(2)}</span>
                              {/*<div className="dot__list--section">
                            <ol className="dot__list">
                              <li></li>
                              <li></li>
                              <li></li>
                              <div className="edit__btn--section edit__btn--show">
                                <button className="btn edit__btn btn__orange" onClick={this.editPurchase.bind(this, val)}>Edit</button>
                              </div>
                            </ol>
                          </div>*/}
                            </div>
                          </li>
                        )
                      })
                    ) : (
                      <div className="purchases__blank">
                        <h2 className="purchases__title">
                          You Have No Purchases
                        </h2>
                        <div className="purchases__blank--img">
                          <img src={NoPurchases} />
                        </div>
                        <Link to="/">
                          <button className="btn ticket_btn purchase">
                            Browse Brands
                          </button>
                        </Link>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Modal
          centered={true}
          id="log__sale--modal"
          isOpen={purchaseModal}
          className={this.props.className}
        >
          <ModalHeader>
            Log a Purchase with {brandTitle}
            <button onClick={this.resetState.bind(this)} className="close__btn">
              <img src={CloseBtn} />
            </button>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="exampleEmail">ENTER THE TOTAL AMOUNT</Label>
              <NumberFormat
                id="exampleEmail"
                thousandSeparator={true}
                className="form-control"
                name="amount"
                value={amount}
                onChange={this.handleChange}
                placeholder="0.00"
                isNumericString={true}
                fixedDecimalScale={true}
                decimalScale={2}
              />
              <FormFeedback>{'amount' in err ? err.amount : ''} </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="exampleSelectMulti">NUMBER OF ITEMS</Label>
              <Input
                type="select"
                name="items"
                value={items}
                onChange={this.handleChange}
                id="exampleSelectMulti"
              >
                <option>&nbsp;</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
                <option>13</option>
                <option>14</option>
                <option>15</option>
                <option>16</option>
                <option>17</option>
                <option>18</option>
                <option>19</option>
                <option>20</option>
              </Input>
              <FormFeedback>{'items' in err ? err.items : ''} </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="exampleText">DESCRIPTION</Label>
              <Input
                type="textarea"
                name="description"
                value={description}
                onChange={this.handleChange}
                id="exampleText"
              />
              <FormFeedback>
                {'description' in err ? err.description : ''}{' '}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="exampleEmail">BRAND KEY</Label>
              <Input
                type="text"
                name="brandKey"
                value={brandKey}
                onChange={this.handleChange}
                id="username"
                placeholder=""
              />
              <FormFeedback>
                {'brandKey' in err ? err.brandKey : ''}{' '}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {isLoading ? (
              <Button
                className="btn btn-primary btn-block btn-lg"
                color="primary"
              >
                Requesting...
              </Button>
            ) : (
              <Button
                className="btn btn-primary btn-block btn-lg"
                color="primary"
                onClick={this.submitForm.bind(this)}
              >
                SUBMIT
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default MyPurchase
